import React from "react";
import { Heading, Stack, Text } from "@origin-digital/ods-core";

interface CategoryFallbackProps {
  "data-id"?: string;
}

export const CategoryFallback: React.FC<CategoryFallbackProps> = ({
  "data-id": dataId = "category-fallback",
}) => (
  <Stack space="small" data-id={dataId}>
    <Heading variant="h4">No content available right now</Heading>
    <Text>Please try again later.</Text>
  </Stack>
);
